import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import logoImg from "@/assets/logo-hitchef.png";

const Navbar = () => {
  const { user } = useAuth();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background/90 backdrop-blur-md border-b border-border">
      <div className="container px-4 mx-auto">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <img src={logoImg} alt="Хит Шеф" className="w-8 h-8 rounded-lg object-cover" width={32} height={32} loading="eager" />
            <span className="font-display text-lg font-bold text-foreground">Хит Шеф</span>
          </Link>

          <div className="hidden md:flex items-center gap-6 text-sm text-muted-foreground">
            <a href="#how-it-works" className="hover:text-foreground transition-colors">Как работает</a>
            <a href="#reviews" className="hover:text-foreground transition-colors">Отзывы</a>
            <a href="#faq" className="hover:text-foreground transition-colors">FAQ</a>
          </div>

          <div className="flex items-center gap-3">
            {user && (
              <Link
                to="/account"
                className="hidden sm:inline-flex items-center h-9 px-4 rounded-lg text-sm font-medium text-foreground hover:bg-muted transition-colors"
              >
                Личный кабинет
              </Link>
            )}
            <Button asChild size="sm" className="bg-primary hover:bg-primary/90 text-primary-foreground font-bold shadow-sm">
              <Link to={user ? "/create" : "/auth"}>
                🔥 Создать песню
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
